// Standaard media van de website. Admin kan elk item overschrijven via
// site_content.image_overrides (upload of link); leeg/afwezig = standaard.
const A = "https://customer-assets-gfyr7b9c.emergentagent.net/job_joh-boxing-preview/artifacts";

export const DEFAULT_MEDIA = {
  "site.hero_video": "/media/hero.mp4",
  "site.hero_poster": "/media/hero-poster.jpg",
  "home.training.boxing101": `${A}/bxymv9fk_WhatsApp%20Image%202026-07-31%20at%2016.54.41%20%281%29.webp`,
  "home.training.boxing": `${A}/6gseu00s_WhatsApp%20Image%202026-07-31%20at%2016.54.41.webp`,
  "home.training.bag": `${A}/89iebkr2_WhatsApp%20Image%202026-07-31%20at%2016.55.02.webp`,
  "home.training.sparring": `${A}/x2srsp5j_WhatsApp%20Image%202026-07-31%20at%2017.13.50.webp`,
  "home.training.pt": `${A}/x2srsp5j_WhatsApp%20Image%202026-07-31%20at%2017.13.50.webp`,
  "home.community.1": `${A}/l1w5gl5e_WhatsApp%20Image%202026-07-31%20at%2016.54.40.webp`,
  "home.community.2": `${A}/bxymv9fk_WhatsApp%20Image%202026-07-31%20at%2016.54.41%20%281%29.webp`,
  "home.community.3": `${A}/x2srsp5j_WhatsApp%20Image%202026-07-31%20at%2017.13.50.webp`,
  "home.about.coach": `${A}/lg2i0zb8_ChatGPT%20Image%2017%20aug%202026%2C%2001_34_35.png`,
  "welkom.gym": `${A}/89iebkr2_WhatsApp%20Image%202026-07-31%20at%2016.55.02.webp`,
  "welkom.coach": `${A}/6gseu00s_WhatsApp%20Image%202026-07-31%20at%2016.54.41.webp`,
  "welkom.lineup": `${A}/bxymv9fk_WhatsApp%20Image%202026-07-31%20at%2016.54.41%20%281%29.webp`,
  "welkom.group": `${A}/l1w5gl5e_WhatsApp%20Image%202026-07-31%20at%2016.54.40.webp`,
};

// Beheer-structuur voor de admin Media-tab (volgorde = weergave).
export const MEDIA_GROUPS = [
  {
    label: "Gedeeld (home + landingpage)",
    slots: [
      { key: "site.hero_video", label: "Hero-video (bovenaan de pagina)", kind: "video" },
      { key: "site.hero_poster", label: "Video-poster (laadbeeld)", kind: "image" },
    ],
  },
  {
    label: "Homepagina — Trainingen",
    slots: [
      { key: "home.training.boxing101", label: "Boxing 101", kind: "image" },
      { key: "home.training.boxing", label: "Boxing Training", kind: "image" },
      { key: "home.training.bag", label: "Bag Training", kind: "image" },
      { key: "home.training.sparring", label: "Sparring", kind: "image" },
      { key: "home.training.pt", label: "Personal Training", kind: "image" },
    ],
  },
  {
    label: "Homepagina — Community",
    slots: [
      { key: "home.community.1", label: "Community foto 1", kind: "image" },
      { key: "home.community.2", label: "Community foto 2", kind: "image" },
      { key: "home.community.3", label: "Community foto 3", kind: "image" },
    ],
  },
  {
    label: "Homepagina — Over JOH.",
    slots: [
      { key: "home.about.coach", label: "Coach-foto (Over JOH.)", kind: "image" },
    ],
  },
  {
    label: "Landingpage (welkom)",
    slots: [
      { key: "welkom.gym", label: "Gym (grote foto)", kind: "image" },
      { key: "welkom.coach", label: "Coach (portret)", kind: "image" },
      { key: "welkom.lineup", label: "Line-up (portret)", kind: "image" },
      { key: "welkom.group", label: "Groep (breed)", kind: "image" },
    ],
  },
];
